import React from "react";
import { useBusinessContext } from "../../context/business";
import { NavLink } from "react-router-dom";
import success from "../../assets/svg/success.svg";

export default function Success() {
  const {
    businessData: { businessData },
  } = useBusinessContext();

  return (
    !!businessData && (
      <div className="success_page">
        <div className="wrapper success_page_wrapper">
          <img src={success} alt="" className="illustration" />

          <p className="thick">Booking Successful</p>

          <p>
            You have successfully booked an appointment with <br />
            <strong>{businessData.name}</strong>.
            <br />
            <br />
            An email will be sent to you shortly containing your appointment
            details.
          </p>
          {businessData?.custom_booking_success_message && (
            <>
              <br />
              <br />

             
              <p style={{ whiteSpace: "pre-line" }}>
                {businessData?.custom_booking_success_message}
              </p>
              <a
                href={businessData?.custom_booking_success_btn_link}
                target="_blank"
                rel="noopener noreferrer"
                className="round_button"
              >
                {businessData?.custom_booking_success_btn_text}
              </a>
              <br />
            </>
          )}
          <NavLink
            to={`/${businessData.identifier}`}
            className="round_button invert"
          >
            Dismiss
          </NavLink>
        </div>
      </div>
    )
  );
}
